var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"title"},[_vm._v("Anleitungen")]),_c('a',{attrs:{"href":_vm.urlHowToPdf,"target":"_blank"}},[_vm._v("- TopQ Tool")]),_c('br'),_c('h2',{staticClass:"title"},[_vm._v("Erklärvideos")]),_c('HowToVideoList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }